export const SUPABASE_URL = "https://ynlnbivbvqwthrycarre.supabase.co";
export const SUPABASE_PUBLISHABLE_KEY =
  "sb_publishable_lNtqdi5-Gwo8KJ6MhkQQsA_jqTD4IOR";
